import BaseServiceV2 from "./BaseServiceV2";
import ApiUrl from './ApiUrl';

class BatchParameterv2 extends BaseServiceV2 {

    constructor() {
        super(ApiUrl.SGKDomain + ApiUrl.controller.SGKBatchParameter);
    }

    async getDonem() {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.Calismadonemi, null);
        return resultObject?.calismaDonemi;
    }
}

const batchParameterv2 = new BatchParameterv2();

export default batchParameterv2;